export default __webpack_public_path__ + "static/prod4-606bebf5c4fabf07272236c8f32a74cd.jpg";